export function userIsEnabledForReporting(acl = [], features = {}) {
  const visibleFor = features?.reporting?.visibleFor;
  if (visibleFor && Array.isArray(visibleFor)) {
    const userRoles = acl.map(a => a.role).concat("all");
    return userRoles.some(role => visibleFor.includes(role));
  }
  // Otherwise return false
  return false;
}
